import React, { useState } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';

const BlogComments = () => {
    const [author, setAuthor] = useState('');
    const [comment, setComment] = useState('');

    const handleSubmit = async () => {
        if (!author || !comment) {
            alert("Author and Comment are required!");
            return;
        }

        try {
            const response = await axios.post('https://alaussback-production.up.railway.app/api/comments', {
                author,
                comment
            });
            alert("Comment submitted successfully!");
            setAuthor('');
            setComment('');
        } catch (error) {
            console.error("Error submitting comment:", error);
            alert("Error submitting comment.");
        }
    };

    return (
        <div className="clear" id="comment-list">
            <div className="comments-area" id="comments">
                <div className="p-tb30">
                    <div className="comment-respond m-t30" id="respond">
                        <h2 className="comment-reply-title" id="reply-title" style={{ fontFamily: 'Cairo, sans-serif' }}>
                            أترك لنا تعليق
                            <small>
                                <NavLink to={""} style={{ display: 'none' }} id="cancel-comment-reply-link" rel="nofollow">Cancel reply</NavLink>
                            </small>
                        </h2>
                        <form className="comment-form bdr-1 bdr-solid bdr-gray p-a20" id="commentform">
                            <p className="comment-form-author">
                                <label htmlFor="author">Name <span className="required">*</span></label>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="user-comment"
                                    placeholder="الإسم و اللقب"
                                    id="author"
                                    value={author}
                                    onChange={(e) => setAuthor(e.target.value)}
                                />
                            </p>
                            {/* Email and URL are optional fields - remove or handle as needed */}
                            <p className="comment-form-comment">
                                <label htmlFor="comment">التعليق</label>
                                <textarea
                                    className="form-control"
                                    rows={8}
                                    name="comment"
                                    placeholder="التعليق"
                                    id="comment"
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                />
                            </p>
                            <p className="form-submit">
                                <button
                                    className="site-button button-sm radius-no text-uppercase font-weight-600"
                                    type="button"
                                    onClick={handleSubmit}
                                >
                                    أضف التعليق
                                </button>
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogComments;
